<template>
    <div class="layout">
        <div class="page-5 page">
            <Header :activeIndex="'2'"></Header>
            <div class="page-section">
				<a @click="handleClick2">
                <div class="section-tab" >
                    <div class="section-center">   
                        <el-tabs style="position: relative;top: 0;font-size: 26px;" v-model="activeName" type="card" @tab-click="handleClick">                            
							
                        </el-tabs>
                    </div>
                </div></a>
                <div class="section-sub-tab" v-if="activeName=='first'" id="section-sub-tab">
                    <div class="sec-bot">
                        <div class="section-center">
                            <h4 class="sec-tit"><i class="el-icon-caret-right"></i><span>地方金融行业垂直模型应用场景</span></h4>
                            <el-tabs v-model="activeName1" type="card" @tab-click="handleClick1">                            
                                <el-tab-pane v-for="(item,index) in subTab1" :key="index" :label="item.name" :name="String(index)">
                                    <div class="flex">
                                        <div class="l">
                                            <div>
                                                <p>{{item.scence}}</p>
                                            </div>
                                            <div>
                                                <p>{{item.value}}</p>
                                            </div>
											<div class="value2-container"><p>{{item.value2}}</p></div>
                                        </div>
										<!--
                                        <div class="r">
                                            <img v-if="!(Array.isArray(item.img))" :src="item.img" alt="">
                                            <div v-else>
                                                <el-carousel height="39vh" indicator-position="outside" v-if="activeName1==String(3)">
                                                    <el-carousel-item v-for="(it,index) in item.img" :key="index">
                                                        <img :src="it" alt="">
                                                    </el-carousel-item>
                                                </el-carousel>
                                            </div>
                                        </div>
										-->
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
                <div class="section-sub-tab" v-if="activeName=='second'" id="section-sub-tab">
                    <div class="sec-bot">
                        <div class="section-center">
                            <div class="second-tab-image">
                                <img src="../../assets/img/page1-5.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer></Footer>
        </div>
    </div>
</template>

<script>
import { Header, Footer } from "../common/common.js";
import B1 from '../../assets/img/page1-1.png'
import B4 from '../../assets/img/Group17.jpg'

  export default {
    components: {
        Header,
        Footer,
    },
    name: '',
    data () {
      return {
        activeName: 'first',
        subTab: [],
        activeName1: '0',
        subTab1: [
            {
                name: '智能客服',
                scence: '客服智能体：基于行业数据集和客户私域知识库，创建高拟人化客服机器人，可准确识别用户意图，实现精准匹配用户问题。支持自动记录高频问答，实现全自动化运行。',
                value: '智能质检：通过智能分析客服对话内容，对服务过程中的合规性进行自动监督，有效提升服务质量并降低企业成本负担。通过洞察客户意图对客服质量进行动态评价。',
				value2: '客户服务：支持智能纪要，智能代办，智能工单服务。通过语音或文字方式智能生成工单，自动推送到相关部门，并通过短信或邮件通知客户回访，实施全流程自动化运作。',
                img: B4
            },
            {
                name: '营销提效',
                scence: '舆情与市场分析：用于需求分析、市场商业洞察、热点分析等。总结提取市场用户对品牌、产品功能、服务的的评价和观点，为市场决策提供支持。',
                value: '智能营销：通过完善用户画像标签体系，为用户提供个性化服务体验。实现金融产品智能推荐，提升营销效果转化。',
                value2: '营销方案：支持快速生成营销方案，激发创意灵感，提升营销创作效率。',
				img: B1
            },
            {
                name: '风控合规审查',
                scence: '智能审查：通过智能化手段，提升消保审查、公文规范审查等领域的工作效率和准确度。自动化执行相关审查任务，确保合规性。',
                value: '智能报告：辅助自动化生成反洗钱可疑报告、法审报告等规范格式报告，简化繁琐重复的报告撰写工作，提升风控合规审查效率。',
                value2: '舆情监测：构建全天7X24小时的舆情监测网络，实时监测市场动态和风险信号，提升风险预警响应时效。',
				img: B4
            }
        ],
      }
    },
    mounted() {
        this.$nextTick(()=>{
            if(this.$route.query.sec){
                var sec = this.$route.query.sec
                this.activeName = sec
            }
        })
    },
    methods: {
        handleClick() {
			window.open("https://haosuan.com/portal/deepSeekChat/");
        },
        handleClick2() {
			window.open("https://haosuan.com/portal/deepSeekChat/");
			
        }
    }
        

  }
</script>

<style>
.a-btn { 
width:50px;
height:40px;
text-align:center;
line-height:40px;
border-radius:6px;
margin:2.1481vh auto 3.5185vh;
background: #3498ef;font-size: 16px;
}

    .page-5 .page-section .section-tab {  
        background: url('../../assets/img/Group12-1.png') no-repeat;
        background-size: cover;
        background-position: center;
        min-width: 1200px;
        height: 400px;
        min-height: 400px;
        padding: 0;
    }
    .page-5 .page-section .section-sub-tab {
        background: url('../../assets/img/Group16.jpg') no-repeat; 
        background-size: cover;
        background-position: center;
        min-width: 1200px;
        padding: 0;
        box-sizing: border-box;
        min-height: auto;
        height: auto;
    }
    .page-5 .page-section .section-sub-tab .value2-container {
        margin-top: 7%;
    }
    .page-5 .page-section .section-sub-tab .second-tab-image {
        text-align: center;
        margin-top: -5.5556vh;
    }

    @media screen and (max-width: 768px) {
        html, body, #app {
            min-height: auto !important;
            height: auto !important;
            min-width: 100% !important;
            width: 100% !important;
        }
        .layout,
        .page-5,
        .page-5 .page {
            min-width: 100% !important;
            width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
            min-height: auto !important;
            height: auto !important;
            overflow-x: hidden !important;
        }
        .page-5 .page-section {
            min-width: 100% !important;
            width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
            min-height: auto !important;
            height: auto !important;
            overflow-x: hidden !important;
        }
        .page-5 .page-section .section-tab {
            height: 270px !important;
            min-height: 270px !important;
            max-height: none !important;
            padding-top: 70px !important;
            padding-left: 0 !important;
            padding-right: 0 !important;
            padding-bottom: 0 !important;
            margin: 0 !important;
            min-width: 100% !important;
            width: 100% !important;
            background-size: 110% !important;
            background-position: 20% center !important;
            position: relative !important;
            overflow-x: hidden !important;
        }
        .page-5 .page-section .section-tab .section-center {
            padding: 0 10px !important;
            height: auto !important;
            min-height: 0 !important;
            width: 100% !important;
            box-sizing: border-box !important;
        }
        .page-5 .page-section .section-tab .section-center .el-tabs {
            position: static !important;
            margin-left: 0 !important;
            top: auto !important;
            left: auto !important;
            font-size: 16px !important;
            height: auto !important;
            min-height: 0 !important;
            width: 100% !important;
            padding: 0 !important;
        }
        .page-5 .page-section .section-tab .el-tabs--card>.el-tabs__header {
            margin-bottom: 0 !important;
            padding-left: 0 !important;
            height: auto !important;
            padding: 0 !important;
        }
        .page-5 .page-section .section-tab .el-tabs--card>.el-tabs__header .el-tabs__nav {
            height: auto !important;
            padding: 0 !important;
        }
        .page-5 .page-section .section-tab .el-tabs--card>.el-tabs__header .el-tabs__item {
            display: none !important;
        }
        .page-5 .page-section .section-sub-tab {
            min-width: 100% !important;
            width: 100% !important;
            min-height: 0 !important;
            height: auto !important;
            padding: 0 !important;
            margin: 0 !important;
            background-size: cover !important;
            background-position: center !important;
            margin-top: -30px !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot {
            padding: 0 !important;
            margin: 0 !important;
            height: auto !important;
            min-height: 0 !important;
            width: 100% !important;
            padding-top: 30px !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot .l {
            width: 100% !important;
            padding: 10px !important;
            box-sizing: border-box !important;
            margin: 0 !important;
            justify-content: space-around !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot .l>div {
            margin-bottom: 10px !important;
            padding: 0 !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot .l>div:nth-of-type(2) {
            margin-bottom: 10px !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot .l>div h4 {
            margin-bottom: 5px !important;
            margin-top: 0 !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot .l>div p {
            margin-bottom: 0 !important;
            margin-top: 0 !important;
        }
        .page-5 .page-section .section-sub-tab .sec-bot .flex {
            flex-direction: column !important;
        }
        .page-5 .page-section .section-sub-tab .sec-tit {
            font-size: 1.2rem !important;
            font-weight: 700 !important;
            color: #000 !important;
        }
        .page-5 .page-section .section-sub-tab .el-tabs--card>.el-tabs__header .el-tabs__item {
            font-weight: 700 !important;
            font-size: 16px !important;
        }
        .page-5 .page-section .section-sub-tab .value2-container {
            margin-top: 0 !important;
            padding: 0 !important;
        }
        .page-5 .page-section .section-sub-tab .second-tab-image {
            margin-top: 0 !important;
            padding: 0 !important;
        }
        .page-5 .page-section .section-sub-tab .second-tab-image img {
            width: 100% !important;
            height: auto !important;
        }
        .page-5 .common-head {
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            width: 100% !important;
            z-index: 999 !important;
            background: rgba(0,0,0,0.8) !important;
            height: 70px !important;
            line-height: 70px !important;
        }
        .page-5 .common-head .flex-box {
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 10px !important;
            box-sizing: border-box !important;
            height: 100% !important;
        }
        .page-5 .common-head .flex-box .logo {
            width: 30% !important;
            max-width: 150px !important;
            height: 100% !important;
        }
        .page-5 .common-head .nav-list {
            width: 70% !important;
            float: right !important;
            display: block !important;
        }
        .page-5 .common-head .nav-list .el-menu--horizontal {
            display: flex !important;
            justify-content: flex-end !important;
            align-items: center !important;
            height: 100% !important;
        }
        .page-5 .common-head .nav-list .el-menu--horizontal .el-menu-item {
            padding: 0 8px !important;
            margin: 0 !important;
            font-size: 12px !important;
            height: 70px !important;
            line-height: 70px !important;
        }
        .page-5 .common-head .nav-list .el-menu--horizontal .el-menu-item.sub-menu .cont-center {
            display: none !important;
        }
        .page-5 .common-foot {
            min-width: 100% !important;
            width: 100% !important;
            padding: 0 !important;
            margin: 0 !important;
        }
        .page-5 .common-foot .foot-center {
            width: 100% !important;
            max-width: 100% !important;
            padding: 0 10px !important;
            box-sizing: border-box !important;
            flex-direction: column !important;
        }
        .page-5 .common-foot .foot-center > div {
            width: 100% !important;
            border-right: none !important;
            border-bottom: 1px solid #e8e8e8 !important;
            padding: 10px !important;
            box-sizing: border-box !important;
        }
        .page-5 .common-foot .p-r {
            padding-left: 0 !important;
        }
        .page-5 .common-foot .p-ab {
            position: static !important;
            text-align: left !important;
        }
    }
</style>

